var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#d7d3d1;}")),React.createElement("path",{"className":"cls-1","d":"M438.7,236.3c-111.8,0-202.5,90.7-202.5,202.5s90.7,202.5,202.5,202.5,202.5-90.7,202.5-202.5c-.1-111.8-90.7-202.4-202.5-202.5ZM438.7,573.8c-74.6,0-135-60.4-135-135s60.4-135,135-135,135,60.4,135,135-60.4,135-135,135ZM641.2,0H236.2C105.8.1.1,105.8,0,236.2v405c.1,130.4,105.8,236.1,236.2,236.2h405c130.4-.1,236.1-105.8,236.2-236.2V236.2C877.3,105.8,771.6.1,641.2,0h0ZM809.9,641.3c0,93.2-75.6,168.8-168.8,168.8H236.1c-93.2,0-168.8-75.6-168.8-168.8V236.3c0-93.2,75.6-168.8,168.8-168.8h405c93.2,0,168.8,75.6,168.8,168.8v405ZM708.7,219.4c0,28-22.7,50.6-50.6,50.6s-50.6-22.7-50.6-50.6,22.7-50.6,50.6-50.6,50.6,22.7,50.6,50.6Z","key":1})]);
}

Instagram.defaultProps = {"id":"Layer_1","viewBox":"0 0 877.4 877.4"};

module.exports = Instagram;

Instagram.default = Instagram;
